module.exports = __webpack_public_path__ + "img/newletter-27.35c091e.jpg";